<template>
  <div :class="['option-wrapper',props.checked ? 'checked' : '', selectable.assets ? 'asset-selectable' : 'asset-readonly']" @click="onAssetSelection">
    <div v-if="selectable.assets"  class="radio-button-wrapper">
      <CRadioIcon :active="props.checked" />
    </div>
    <div class="car-details-wrapper">
      <div v-if="props.logo" class="car-logo">
        <img :src="props.logo" width="30" height="30" />
      </div>
      <div class="car-general-details">
        <p class="car-name">{{ props.title }}</p>
        <p class="car-details">{{ props.details }}</p>
      </div>
    </div>
    <div class="car-plate-wrapper">
      <CLicencePlate :vehicle="licencePlateAdapter" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import AuthService from '@/general/services/AuthService';
  import CLicencePlate from '@/shared/components/CLicencePlate.vue';
  import CRadioIcon from '@/shared/components/form/CRadioIcon.vue';
  import { getDefaultCountryId } from '@/shared/models/Country';
  import Vehicle from '@/vehicle/models/Vehicle';

  const props = defineProps<{
    checked: boolean,
    licensePlate: string,
    logo: string,
    title: string,
    details: string,
    valueId: string,
    selectable:{
      groups: boolean,
      classes: boolean,
      assets: boolean
    }
  }>();

  const emit = defineEmits<{
    (e: 'change', v: string): void
  }>();

  const onAssetSelection = () => {
    if (props.selectable.assets) {
      emit('change', `${props.valueId}`);
    }
  };

  const licencePlateAdapter = computed(() => {
    return ({
      registrationNumber: props.licensePlate,
      countryId: AuthService.getCurrentUser().countryId ?? getDefaultCountryId(),
    } as unknown) as Vehicle;
  });
</script>

<style lang="scss">
  .option-wrapper{
      padding-block: 5px;
      display: flex;
      border-radius: 5px;
      border: 1px solid lightgray;
      height: 56px;
      background-color: $neutral-0;
      outline-offset: -2px;
  }

  .option-wrapper.checked{
      background-color: #e0f4ff;
      outline: 2px solid #64b8e6;
      border: 1px solid #64b8e6;
  }

  .radio-button-wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-inline: 15px 5px;
  }

  .asset-selectable {
      cursor: pointer;
  }

  .asset-selectable:not(.checked):hover {
    border: 1px solid #ABB5BA;
  }

  .asset-readonly .car-details-wrapper {
    padding-left: 8px;
  }

  .car-details-wrapper{
      display: flex;
      flex: 1;
      align-items: center;
  }

  .car-logo{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-inline: 4px 0px;
      color: #212528;
  }

  .car-name{
      font-size: 16px;
      line-height:18px;
      font-weight: 500;
      margin-bottom: 0!important;
      color: #212528;
  }

  .car-details{
      font-size: 12px;
      line-height: 14px;
  }

  .car-general-details{
      display: flex;
      flex-direction: column;
      gap: 3px;
      padding-left: 7px;
  }

  .car-plate-wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 15px;
  }
</style>
